import React, { useState } from 'react';

import Accordion from 'react-bootstrap/Accordion';
import Carousel, { Modal, ModalGateway } from 'react-images';
import { BulletinMessagesMap } from '../types';
import Question from '../../../icons/Question';
import MapImageButton from './MapImageButton';
import MessageInput from './MessageInput';

const formatText = (text?: string) =>
  text?.replace(/(?:\r\n|\r|\n)/g, '<br />');

function MapMessageLine({ map }: { map: BulletinMessagesMap }) {
  const [imageModalOpen, setImageModalOpen] = useState<string | undefined>();
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: 10,
      }}
      data-cy={`map-message-line-${map.map_id}`}
    >
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          gap: 10,
        }}
      >
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            gap: 10,
            flex: 1,
            flexWrap: 'wrap',
          }}
        >
          <div
            style={{
              display: 'flex',
              flex: 1,
              minWidth: 150,
              gap: 10,
            }}
          >
            <MessageInput
              label="Message on map"
              id={map.map_id.toString()}
              defaultValue={map.content}
              multiline
              type="map"
            />
          </div>
          <div style={{ width: 200 }}>
            <MapImageButton
              src={map.source}
              onClick={() => setImageModalOpen(map.source)}
              alt=""
            />
          </div>
        </div>
      </div>
      <Accordion>
        <Accordion.Item eventKey="0">
          <Accordion.Header style={{ marginTop: 0 }}>
            <span style={{ display: 'flex', gap: 5 }}>
              <Question />
              <span>Help</span>
            </span>
          </Accordion.Header>
          <Accordion.Body
            style={{
              display: 'flex',
              flexDirection: 'column',
              gap: 5,
            }}
          >
            <p>
              <strong>What to check: </strong>
              {formatText(map.help_text?.legend)}
            </p>
            <p>
              <strong>Description: </strong>
              {formatText(map.help_text?.legend_warn)}
            </p>
            <p>
              <strong>Reference Image:</strong>
            </p>
            {map.help_text?.image ? (
              <MapImageButton
                src={map.help_text.image}
                onClick={() => setImageModalOpen(map.help_text?.image)}
                alt=""
              />
            ) : (
              <p>No reference image available</p>
            )}
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
      <ModalGateway>
        {imageModalOpen && (
          <Modal onClose={() => setImageModalOpen(undefined)}>
            <Carousel
              views={[
                {
                  source: imageModalOpen,
                  caption: '',
                },
              ]}
              currentIndex={0}
            />
          </Modal>
        )}
      </ModalGateway>
    </div>
  );
}

export default MapMessageLine;
